export const mqLaptop = window.matchMedia('(max-width: 1444px)');
export const mqTabletLandscape = window.matchMedia('(max-width: 1279px)');
export const mqTabletPortrait = window.matchMedia('(max-width: 1023px)');
export const mqAdminBar = window.matchMedia('(max-width: 782px)');
export const mqPhone = window.matchMedia('(max-width: 767px)');